import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function MultilineText(props) {
    const { label, verticalPosition } = props;
    if (!label)
        return;
    const lines = label.split(/\r?\n/);
    const firstDX = verticalPosition === 'top'
        ? 1
        : verticalPosition === 'center'
            ? -lines.length / 2 + 0.5
            : -lines.length;
    return (_jsx(_Fragment, { children: lines.map((line, index) => (_jsx("tspan", { x: "0", dy: index === 0 ? `${firstDX}em` : '1em', children: line }, index))) }));
}
//# sourceMappingURL=MultilineText.js.map